export default __webpack_public_path__ + "static/media/kpi.05b3042e.svg";